/**
 * Prisma Zod Generator - Single File (inlined)
 * Auto-generated. Do not edit.
 */

import * as z from 'zod';
// File: TransactionIsolationLevel.schema.ts

export const TransactionIsolationLevelSchema = z.enum(['ReadUncommitted', 'ReadCommitted', 'RepeatableRead', 'Serializable'])

export type TransactionIsolationLevel = z.infer<typeof TransactionIsolationLevelSchema>;

// File: UserScalarFieldEnum.schema.ts

export const UserScalarFieldEnumSchema = z.enum(['id', 'firstName', 'lastName', 'middleName', 'email', 'phone', 'password', 'lastSignedIn', 'identityProvider', 'disabled', 'emailVerified', 'type', 'twoFactorSecret', 'twoFactorEnabled', 'twoFactorBackupCodes', 'createdAt', 'updatedAt'])

export type UserScalarFieldEnum = z.infer<typeof UserScalarFieldEnumSchema>;

// File: UserSecurityAuditLogScalarFieldEnum.schema.ts

export const UserSecurityAuditLogScalarFieldEnumSchema = z.enum(['id', 'type', 'userAgent', 'ipAddress', 'userId', 'createdAt'])

export type UserSecurityAuditLogScalarFieldEnum = z.infer<typeof UserSecurityAuditLogScalarFieldEnumSchema>;

// File: PasswordResetTokenScalarFieldEnum.schema.ts

export const PasswordResetTokenScalarFieldEnumSchema = z.enum(['id', 'token', 'createdAt', 'expiry', 'userId'])

export type PasswordResetTokenScalarFieldEnum = z.infer<typeof PasswordResetTokenScalarFieldEnumSchema>;

// File: PasskeyScalarFieldEnum.schema.ts

export const PasskeyScalarFieldEnumSchema = z.enum(['id', 'userId', 'name', 'createdAt', 'updatedAt', 'lastUsedAt', 'credentialId', 'credentialPublicKey', 'counter', 'credentialDeviceType', 'credentialBackedUp', 'transports'])

export type PasskeyScalarFieldEnum = z.infer<typeof PasskeyScalarFieldEnumSchema>;

// File: AnonymousVerificationTokenScalarFieldEnum.schema.ts

export const AnonymousVerificationTokenScalarFieldEnumSchema = z.enum(['id', 'token', 'expiresAt', 'createdAt'])

export type AnonymousVerificationTokenScalarFieldEnum = z.infer<typeof AnonymousVerificationTokenScalarFieldEnumSchema>;

// File: VerificationTokenScalarFieldEnum.schema.ts

export const VerificationTokenScalarFieldEnumSchema = z.enum(['id', 'secondaryId', 'identifier', 'token', 'completed', 'expires', 'createdAt', 'userId'])

export type VerificationTokenScalarFieldEnum = z.infer<typeof VerificationTokenScalarFieldEnumSchema>;

// File: AccountScalarFieldEnum.schema.ts

export const AccountScalarFieldEnumSchema = z.enum(['id', 'userId', 'type', 'provider', 'providerAccountId', 'refresh_token', 'access_token', 'expires_at', 'created_at', 'ext_expires_in', 'token_type', 'scope', 'id_token', 'session_state', 'createdAt', 'updatedAt'])

export type AccountScalarFieldEnum = z.infer<typeof AccountScalarFieldEnumSchema>;

// File: SessionScalarFieldEnum.schema.ts

export const SessionScalarFieldEnumSchema = z.enum(['id', 'sessionToken', 'userId', 'ipAddress', 'userAgent', 'expiresAt', 'createdAt', 'updatedAt'])

export type SessionScalarFieldEnum = z.infer<typeof SessionScalarFieldEnumSchema>;

// File: UserOrganizationScalarFieldEnum.schema.ts

export const UserOrganizationScalarFieldEnumSchema = z.enum(['id', 'role', 'invitedAt', 'joinedAt', 'createdAt', 'updatedAt', 'userId', 'organizationId'])

export type UserOrganizationScalarFieldEnum = z.infer<typeof UserOrganizationScalarFieldEnumSchema>;

// File: OrganizationScalarFieldEnum.schema.ts

export const OrganizationScalarFieldEnumSchema = z.enum(['id', 'name', 'description', 'country', 'status', 'createdAt', 'updatedAt'])

export type OrganizationScalarFieldEnum = z.infer<typeof OrganizationScalarFieldEnumSchema>;

// File: FileScalarFieldEnum.schema.ts

export const FileScalarFieldEnumSchema = z.enum(['id', 'originalName', 'storageKey', 'mimeType', 'size', 'width', 'height', 'createdAt', 'updatedAt', 'uploadedBy'])

export type FileScalarFieldEnum = z.infer<typeof FileScalarFieldEnumSchema>;

// File: BackgroundJobScalarFieldEnum.schema.ts

export const BackgroundJobScalarFieldEnumSchema = z.enum(['id', 'status', 'payload', 'retried', 'maxRetries', 'jobId', 'name', 'version', 'submittedAt', 'updatedAt', 'completedAt', 'lastRetriedAt'])

export type BackgroundJobScalarFieldEnum = z.infer<typeof BackgroundJobScalarFieldEnumSchema>;

// File: BackgroundJobTaskScalarFieldEnum.schema.ts

export const BackgroundJobTaskScalarFieldEnumSchema = z.enum(['id', 'name', 'status', 'result', 'retried', 'maxRetries', 'createdAt', 'updatedAt', 'completedAt', 'jobId'])

export type BackgroundJobTaskScalarFieldEnum = z.infer<typeof BackgroundJobTaskScalarFieldEnumSchema>;

// File: RateLimitScalarFieldEnum.schema.ts

export const RateLimitScalarFieldEnumSchema = z.enum(['key', 'action', 'bucket', 'count', 'createdAt'])

export type RateLimitScalarFieldEnum = z.infer<typeof RateLimitScalarFieldEnumSchema>;

// File: WebhookScalarFieldEnum.schema.ts

export const WebhookScalarFieldEnumSchema = z.enum(['id', 'webhookUrl', 'eventTriggers', 'secret', 'enabled', 'userId', 'organizationId', 'createdAt', 'updatedAt'])

export type WebhookScalarFieldEnum = z.infer<typeof WebhookScalarFieldEnumSchema>;

// File: WebhookCallScalarFieldEnum.schema.ts

export const WebhookCallScalarFieldEnumSchema = z.enum(['id', 'status', 'url', 'event', 'requestBody', 'responseCode', 'responseHeaders', 'responseBody', 'webhookId', 'createdAt'])

export type WebhookCallScalarFieldEnum = z.infer<typeof WebhookCallScalarFieldEnumSchema>;

// File: ApiTokenScalarFieldEnum.schema.ts

export const ApiTokenScalarFieldEnumSchema = z.enum(['id', 'name', 'token', 'algorithm', 'expiresAt', 'userId', 'organizationId', 'createdAt'])

export type ApiTokenScalarFieldEnum = z.infer<typeof ApiTokenScalarFieldEnumSchema>;

// File: SortOrder.schema.ts

export const SortOrderSchema = z.enum(['asc', 'desc'])

export type SortOrder = z.infer<typeof SortOrderSchema>;

// File: NullableJsonNullValueInput.schema.ts

export const NullableJsonNullValueInputSchema = z.enum(['DbNull', 'JsonNull'])

export type NullableJsonNullValueInput = z.infer<typeof NullableJsonNullValueInputSchema>;

// File: JsonNullValueInput.schema.ts

export const JsonNullValueInputSchema = z.enum(['JsonNull'])

export type JsonNullValueInput = z.infer<typeof JsonNullValueInputSchema>;

// File: QueryMode.schema.ts

export const QueryModeSchema = z.enum(['default', 'insensitive'])

export type QueryMode = z.infer<typeof QueryModeSchema>;

// File: NullsOrder.schema.ts

export const NullsOrderSchema = z.enum(['first', 'last'])

export type NullsOrder = z.infer<typeof NullsOrderSchema>;

// File: JsonNullValueFilter.schema.ts

export const JsonNullValueFilterSchema = z.enum(['DbNull', 'JsonNull', 'AnyNull'])

export type JsonNullValueFilter = z.infer<typeof JsonNullValueFilterSchema>;

// File: IdentityProvider.schema.ts

export const IdentityProviderSchema = z.enum(['RAVEN', 'GOOGLE', 'OIDC', 'APPLE', 'FACEBOOK'])

export type IdentityProvider = z.infer<typeof IdentityProviderSchema>;

// File: UserType.schema.ts

export const UserTypeSchema = z.enum(['USER', 'ADMIN'])

export type UserType = z.infer<typeof UserTypeSchema>;

// File: UserSecurityAuditLogType.schema.ts

export const UserSecurityAuditLogTypeSchema = z.enum(['ACCOUNT_CREATED', 'ACCOUNT_PROFILE_UPDATE', 'ACCOUNT_SSO_LINK', 'ACCOUNT_SUSPENDED', 'ACCOUNT_REACTIVATED', 'AUTH_2FA_DISABLE', 'AUTH_2FA_ENABLE', 'AUTH_PASSWORD_RESET', 'AUTH_PASSWORD_UPDATE', 'AUTH_SESSION_REVOKED', 'AUTH_SIGN_OUT', 'AUTH_SIGN_IN_SUCCESS', 'AUTH_SIGN_IN_FAILED', 'AUTH_2FA_FAILED', 'AUTH_PASSKEY_FAILED', 'PASSKEY_CREATED', 'PASSKEY_DELETED', 'PASSKEY_UPDATED', 'DATA_EXPORTED', 'DATA_DELETED', 'PERMISSION_CHANGED'])

export type UserSecurityAuditLogType = z.infer<typeof UserSecurityAuditLogTypeSchema>;

// File: VerificationTokenIdentifier.schema.ts

export const VerificationTokenIdentifierSchema = z.enum(['CONFIRMATION_EMAIL', 'ORGANIZATION_INVITATION', 'OTP_CODE', 'PASSKEY_CHALLENGE'])

export type VerificationTokenIdentifier = z.infer<typeof VerificationTokenIdentifierSchema>;

// File: UserRole.schema.ts

export const UserRoleSchema = z.enum(['ORG_OWNER', 'ORG_MANAGER', 'ORG_OFFICER', 'ORG_KYB_OFFICER', 'ORG_KYC_OFFICER', 'ORG_VIEWER'])

export type UserRole = z.infer<typeof UserRoleSchema>;

// File: OrganizationStatus.schema.ts

export const OrganizationStatusSchema = z.enum(['ACTIVE', 'INACTIVE', 'SUSPENDED', 'DELETED', 'UNVERIFIED'])

export type OrganizationStatus = z.infer<typeof OrganizationStatusSchema>;

// File: BackgroundJobStatus.schema.ts

export const BackgroundJobStatusSchema = z.enum(['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED'])

export type BackgroundJobStatus = z.infer<typeof BackgroundJobStatusSchema>;

// File: BackgroundJobTaskStatus.schema.ts

export const BackgroundJobTaskStatusSchema = z.enum(['PENDING', 'COMPLETED', 'FAILED'])

export type BackgroundJobTaskStatus = z.infer<typeof BackgroundJobTaskStatusSchema>;

// File: WebhookTriggerEvents.schema.ts

export const WebhookTriggerEventsSchema = z.enum(['REPORT_GENERATED'])

export type WebhookTriggerEvents = z.infer<typeof WebhookTriggerEventsSchema>;

// File: WebhookCallStatus.schema.ts

export const WebhookCallStatusSchema = z.enum(['SUCCESS', 'FAILED'])

export type WebhookCallStatus = z.infer<typeof WebhookCallStatusSchema>;

// File: ApiTokenAlgorithm.schema.ts

export const ApiTokenAlgorithmSchema = z.enum(['SHA512'])

export type ApiTokenAlgorithm = z.infer<typeof ApiTokenAlgorithmSchema>;

// File: User.schema.ts

export const UserSchema = z.object({
  id: z.string(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  middleName: z.string().nullish(),
  email: z.string(),
  phone: z.string().nullish(),
  password: z.string().nullish(),
  lastSignedIn: z.date(),
  identityProvider: IdentityProviderSchema.default("RAVEN"),
  disabled: z.boolean(),
  emailVerified: z.date().nullish(),
  type: UserTypeSchema.default("USER"),
  twoFactorSecret: z.string().nullish(),
  twoFactorEnabled: z.boolean(),
  twoFactorBackupCodes: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type UserModel = z.infer<typeof UserSchema>;

// File: UserSecurityAuditLog.schema.ts

export const UserSecurityAuditLogSchema = z.object({
  id: z.string(),
  type: UserSecurityAuditLogTypeSchema,
  userAgent: z.string().nullish(),
  ipAddress: z.string().nullish(),
  userId: z.string(),
  createdAt: z.date(),
});

export type UserSecurityAuditLogModel = z.infer<typeof UserSecurityAuditLogSchema>;

// File: PasswordResetToken.schema.ts

export const PasswordResetTokenSchema = z.object({
  id: z.string(),
  token: z.string(),
  createdAt: z.date(),
  expiry: z.date(),
  userId: z.string(),
});

export type PasswordResetTokenType = z.infer<typeof PasswordResetTokenSchema>;


// File: Passkey.schema.ts

export const PasskeySchema = z.object({
  id: z.string(),
  userId: z.string(),
  name: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  lastUsedAt: z.date().nullish(),
  credentialId: z.string().regex(/^[A-Za-z0-9+/]*={0,2}$/, "Must be valid base64 string").max(22369622, "Base64 string too long"),
  credentialPublicKey: z.string().regex(/^[A-Za-z0-9+/]*={0,2}$/, "Must be valid base64 string").max(22369622, "Base64 string too long"),
  counter: z.bigint(),
  credentialDeviceType: z.string(),
  credentialBackedUp: z.boolean(),
  transports: z.array(z.string()),
});

export type PasskeyType = z.infer<typeof PasskeySchema>;


// File: AnonymousVerificationToken.schema.ts

export const AnonymousVerificationTokenSchema = z.object({
  id: z.string(),
  token: z.string(),
  expiresAt: z.date(),
  createdAt: z.date(),
});

export type AnonymousVerificationTokenType = z.infer<typeof AnonymousVerificationTokenSchema>;


// File: VerificationToken.schema.ts

export const VerificationTokenSchema = z.object({
  id: z.string(),
  secondaryId: z.string().cuid(),
  identifier: VerificationTokenIdentifierSchema,
  token: z.string(),
  completed: z.boolean(),
  expires: z.date(),
  createdAt: z.date(),
  userId: z.string(),
});

export type VerificationTokenType = z.infer<typeof VerificationTokenSchema>;


// File: Account.schema.ts

export const AccountSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: z.string(),
  provider: z.string(),
  providerAccountId: z.string(),
  refresh_token: z.string().nullish(),
  access_token: z.string().nullish(),
  expires_at: z.number().int().nullish(),
  created_at: z.number().int().nullish(),
  ext_expires_in: z.number().int().nullish(),
  token_type: z.string().nullish(),
  scope: z.string().nullish(),
  id_token: z.string().nullish(),
  session_state: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AccountType = z.infer<typeof AccountSchema>;


// File: Session.schema.ts

export const SessionSchema = z.object({
  id: z.string(),
  sessionToken: z.string(),
  userId: z.string(),
  ipAddress: z.string().nullish(),
  userAgent: z.string().nullish(),
  expiresAt: z.date(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type SessionType = z.infer<typeof SessionSchema>;


// File: UserOrganization.schema.ts

export const UserOrganizationSchema = z.object({
  id: z.string(),
  role: UserRoleSchema.default("ORG_VIEWER"),
  invitedAt: z.date().nullish(),
  joinedAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: z.string(),
  organizationId: z.string(),
});

export type UserOrganizationType = z.infer<typeof UserOrganizationSchema>;


// File: Organization.schema.ts

export const OrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  country: z.string().nullish(),
  status: OrganizationStatusSchema.default("UNVERIFIED"),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type OrganizationType = z.infer<typeof OrganizationSchema>;


// File: File.schema.ts

export const FileSchema = z.object({
  id: z.string(),
  originalName: z.string(),
  storageKey: z.string(),
  mimeType: z.string(),
  size: z.number().int(),
  width: z.number().int().nullish(),
  height: z.number().int().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  uploadedBy: z.string(),
});

export type FileType = z.infer<typeof FileSchema>;


// File: BackgroundJob.schema.ts

export const BackgroundJobSchema = z.object({
  id: z.string(),
  status: BackgroundJobStatusSchema.default("PENDING"),
  payload: z.unknown().refine((val) => { const getDepth = (obj: unknown, depth: number = 0): number => { if (depth > 10) return depth; if (obj === null || typeof obj !== 'object') return depth; const values = Object.values(obj as Record<string, unknown>); if (values.length === 0) return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
  retried: z.number().int(),
  maxRetries: z.number().int().default(3),
  jobId: z.string(),
  name: z.string(),
  version: z.string(),
  submittedAt: z.date(),
  updatedAt: z.date(),
  completedAt: z.date().nullish(),
  lastRetriedAt: z.date().nullish(),
});

export type BackgroundJobType = z.infer<typeof BackgroundJobSchema>;


// File: BackgroundJobTask.schema.ts

export const BackgroundJobTaskSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: BackgroundJobTaskStatusSchema.default("PENDING"),
  result: z.unknown().refine((val) => { const getDepth = (obj: unknown, depth: number = 0): number => { if (depth > 10) return depth; if (obj === null || typeof obj !== 'object') return depth; const values = Object.values(obj as Record<string, unknown>); if (values.length === 0) return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
  retried: z.number().int(),
  maxRetries: z.number().int().default(3),
  createdAt: z.date(),
  updatedAt: z.date(),
  completedAt: z.date().nullish(),
  jobId: z.string(),
});

export type BackgroundJobTaskType = z.infer<typeof BackgroundJobTaskSchema>;


// File: RateLimit.schema.ts

export const RateLimitSchema = z.object({
  key: z.string(),
  action: z.string(),
  bucket: z.date(),
  count: z.number().int().default(1),
  createdAt: z.date(),
});

export type RateLimitType = z.infer<typeof RateLimitSchema>;


// File: Webhook.schema.ts

export const WebhookSchema = z.object({
  id: z.string(),
  webhookUrl: z.string(),
  eventTriggers: z.array(WebhookTriggerEventsSchema),
  secret: z.string().nullish(),
  enabled: z.boolean().default(true),
  userId: z.string(),
  organizationId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type WebhookType = z.infer<typeof WebhookSchema>;


// File: WebhookCall.schema.ts

export const WebhookCallSchema = z.object({
  id: z.string(),
  status: WebhookCallStatusSchema,
  url: z.string(),
  event: WebhookTriggerEventsSchema,
  requestBody: z.unknown().refine((val) => { const getDepth = (obj: unknown, depth: number = 0): number => { if (depth > 10) return depth; if (obj === null || typeof obj !== 'object') return depth; const values = Object.values(obj as Record<string, unknown>); if (values.length === 0) return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
  responseCode: z.number().int(),
  responseHeaders: z.unknown().refine((val) => { const getDepth = (obj: unknown, depth: number = 0): number => { if (depth > 10) return depth; if (obj === null || typeof obj !== 'object') return depth; const values = Object.values(obj as Record<string, unknown>); if (values.length === 0) return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
  responseBody: z.unknown().refine((val) => { const getDepth = (obj: unknown, depth: number = 0): number => { if (depth > 10) return depth; if (obj === null || typeof obj !== 'object') return depth; const values = Object.values(obj as Record<string, unknown>); if (values.length === 0) return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
  webhookId: z.string(),
  createdAt: z.date(),
});

export type WebhookCallType = z.infer<typeof WebhookCallSchema>;


// File: ApiToken.schema.ts

export const ApiTokenSchema = z.object({
  id: z.string(),
  name: z.string(),
  token: z.string(),
  algorithm: ApiTokenAlgorithmSchema.default("SHA512"),
  expiresAt: z.date().nullish(),
  userId: z.string().nullish(),
  organizationId: z.string(),
  createdAt: z.date(),
});

export type ApiTokenType = z.infer<typeof ApiTokenSchema>;

